/* eslint-disable camelcase */
import { MenuEdition } from './menuEdition';

export class ProductItem extends MenuEdition {
  constructor(props = {}) {
    super(props.guid);
    this.product = props.product || null;
    this.section = props.section || null;
    this.default_order = props.default_order || 0;
    this.is_visible = props.is_visible || false;
    this.out_of_stock = props.out_of_stock || false;
    this.special = props.special || false;
    this.special_frame = props.special_frame || false;
    this.is_special_description = props.is_special_description || false;
    this.special_description_alt1 = props.special_description_alt1 || '';
    this.special_description_alt2 = props.special_description_alt2 || '';
    this.special_description_alt3 = props.special_description_alt3 || '';
    this.allowed_sale_formats = props.allowed_sale_formats || [];
    this.commercial_name = props.commercial_name || '';
    this.name = props.name || '';
    this.is_deleted = props.is_deleted || false;
    this.is_managed = props.is_managed || false;
    this.use_video = props.use_video || false;
  }

  get order() {
    return this.default_order;
  }

  set order(order) {
    this.default_order = order;
  }
}
